import { useApp } from '@libs/hooks';
import React from 'react';
import { ButtonRow } from '../../Buttons/ButtonRow';
import { ActionNameEnum, TServerCalculationFunc } from '../utils/types';
import { CodeTimerScreen } from './CodeTimerScreen';

type TCodeAppliedButton = {
    labelNewCode?: string;
    labelRemoveCode?: string;
    labelUsePromoCode?: string;
    textRemovedCode?: string;
    enterCodePopup: React.ReactNode;
    value: string;
    isFrom: boolean;
    handlingAutoApplied?: boolean;
    onServerCalculation: TServerCalculationFunc;
};
const CodeAppliedButtons = ({
    labelNewCode,
    labelRemoveCode,
    labelUsePromoCode,
    handlingAutoApplied,
    enterCodePopup,
    value,
    isFrom,
    onServerCalculation,
    textRemovedCode,
}: TCodeAppliedButton) => {
    const { setPopup, setModal } = useApp();
    const handleRemoveCodeClick = async () => {
        if (value) {
            const result = await onServerCalculation(value, 'code', isFrom, ActionNameEnum.onRemoveCode);
            if (result) {
                setPopup(null);
                setModal(<CodeTimerScreen text={textRemovedCode} />);
            } else {
                setPopup(null);
            }
        }
    };
    return (
        <>
            <ButtonRow
                as="button"
                isWidget={false}
                label={handlingAutoApplied ? labelUsePromoCode : labelNewCode}
                iconName={'ic_arrow_retry'}
                handleClick={() => setPopup(enterCodePopup)}
            />
            {!handlingAutoApplied && <ButtonRow as="button" isWidget={false} label={labelRemoveCode} iconName={'ic_x'} handleClick={handleRemoveCodeClick} />}
        </>
    );
};
export { CodeAppliedButtons };
